import React, { Component } from 'react';


class ModelSheet extends Component {

  render() {
    const { model } = this.props;
    return (
      <div className="container-fluid text-primary bg-white p-3">
        <div className="row justify-content-center">
          <div className="w-100 px-2">
            <div className="position-absolute">
              <img className="border border-secondary rounded-circle overflow-hidden p-2" width="23%"
                   src={model.image.tc}
                   alt=""/>
            </div>
          </div>
          <img height="100%" width="100%" src={model.image.main} alt=""/>
        </div>
        <div className="row justify-content-center">
          <h6 className="mt-2 text-uppercase">
            {model.name + " " + model.cubicCapacity}
          </h6>
        </div>
        <div className="row justify-content-center">
          <div style={{ width: "40px" }} className="border-top border-secondary mt-2 mb-3">

          </div>
        </div>
        <div className="row justify-content-center">
          <div className="d-flex flex-column">
            <p className="m-0">Cilindrada: {model.cubicCapacity} C.C.</p>
            <p className="m-0">Licencia: {model.requiredLicense}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default ModelSheet;
